import type {SubmitHandler} from 'react-hook-form';
import {useMemo} from 'react';

import {EditableOff, EditableOn} from '../../../Editable';
import {EditableContent} from '../../EditableContent';
import type {EditableFieldsProps} from '../../EditableFields';
import {EditableFields} from '../../EditableFields';

import type {Values} from './schema';
import {schema} from './schema';

import {
  EditableCancelButton,
  EditableEditButton,
  EditableOffControls,
  EditableOnControls,
  EditableSubmitButton,
  FieldAutoResizeTextarea,
  FieldControl,
  FieldInput,
  Label,
  Text,
  VStack,
} from '../../../index';

export type EditableTitleMessageFieldsProps = {
  title?: string;
  message?: string;
  onSubmit?: SubmitHandler<Values>;
} & Omit<EditableFieldsProps<Values>, 'onSubmit'>;

export const EditableTitleMessageFields = (props: EditableTitleMessageFieldsProps) => {
  const {title, message} = props;

  const defaultValues = useMemo(() => ({title, message}), [title, message]);

  return (
    <EditableFields<Values> schema={schema} defaultValues={defaultValues} {...props}>
      <EditableOff>
        <EditableContent>
          <VStack flexGrow={1} alignItems={`stretch`} gap={`space-050`} color={`text.secondary`}>
            <Label size={`sm`} color={`inherit`}>
              {title}
            </Label>
            {message && <Text size={`md`}>{message}</Text>}
          </VStack>
        </EditableContent>
        <EditableOffControls>
          <EditableEditButton />
        </EditableOffControls>
      </EditableOff>
      <EditableOn>
        <EditableContent>
          <FieldControl name={`title`}>
            <FieldInput name={`title`} autoFocus size={`md`} />
          </FieldControl>
          <FieldControl name={`message`}>
            <FieldAutoResizeTextarea name={`message`} minRows={2} maxRows={5} size={`md`} />
          </FieldControl>
        </EditableContent>
        <EditableOnControls>
          <EditableCancelButton />
          <EditableSubmitButton />
        </EditableOnControls>
      </EditableOn>
    </EditableFields>
  );
};
